import * as React from 'react'
import { logger } from '../../common/logger'

interface ErrorBoundaryState {
  hasError: boolean
}

interface GenericProps {
  children: React.ReactNode
  fallback: React.ReactNode
}

export class ErrorBoundary extends React.Component<GenericProps, ErrorBoundaryState> {
  constructor(props: GenericProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: any) {
    // Error usually will be of type Error, but can be any object.
    const castedError = error as Error
    logger.logError(castedError)
    logger.logInfo(`An error was caught in ErrorBoundary: ${castedError?.message}`)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback
    }

    return this.props.children
  }
}
